import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import type { AppDispatch } from './Store';
import * as authModuleActions from './auth/Auth.actions';
import * as authSliceAction from './auth/Auth.slice';
import * as sheetConfigSliceAction from './sheetConfig/sheetConfig.slice';
import * as commonSliceAction from './common/common.slice';
import * as sheetDataSliceAction from './sheetData/sheetData.slice';
import * as mfilesConfigSliceAction from './mfilesConfig/mfilesConfig.slice';
// Custom hook to bind action creators to the dispatch function
export const useActions = () => {
  // Get the dispatch function from the Redux store
  const dispatch = useDispatch<AppDispatch>();

  // Bind the setAuthData action creator to the dispatch function
  // This allows you to directly call setAuthData without manually dispatching it in each component
  return bindActionCreators(
    {
      ...authSliceAction,
      ...authModuleActions,
      ...commonSliceAction,
      ...mfilesConfigSliceAction,
      ...sheetDataSliceAction,
      ...sheetConfigSliceAction,
    },
    dispatch
  );
};
